import { FC } from 'react';

interface IProps {
  value: string | number;
}

const CustomerProfileEditStatisticsField: FC<IProps> = ({ value }: IProps): JSX.Element => {
  return <p className="family-semibold text-size-16 color-dark font-weight-500 text-uppercase">{value}</p>;
};

export default CustomerProfileEditStatisticsField;
